import { Menu } from './menu'
import { top } from './top';
import { ScrollTop } from './scrollTop';
import {createBlob} from "./utils";

new Menu()
new ScrollTop()

gsap.timeline({
  duration: 0.1,
  repeat: -1,
})
  .to('.joinClan', {
    ease: 'bounce.out',
    y: '20px',
  })
  .to('.joinClan', {
    ease: 'bounce.out',
    y: '0px',
  })

document.querySelector('.joinClan').addEventListener('click', () => {
  gsap.timeline({
  })
    .to('.joinClan', {
      duration: 0.05,
      ease: 'bounce.out',
      x: gsap.utils.random(0, 20),
      y: gsap.utils.random(0, 20),
    })
    .to('.joinClan', {
      duration: 0.05,
      ease: 'bounce.out',
      x: gsap.utils.random(-20, 0),
      y: gsap.utils.random(0, 20),
    })
    .to('.joinClan', {
      duration: 0.05,
      ease: 'bounce.out',
      x: gsap.utils.random(0, 20),
      y: gsap.utils.random(0, 20),
    })
    .to('.joinClan', {
      duration: 0.05,
      ease: 'bounce.out',
      x: gsap.utils.random(-20, 0),
      y: gsap.utils.random(0, 20),
    })
    .to('.joinClan', {
      duration: 0.2,
      ease: 'bounce.out',
      x: gsap.utils.random(-1000, 1000),
      y: gsap.utils.random(-1000, 1000),
    })
    .to('.joinClan', {
      duration: 0.1,
      ease: 'expo.out',
      autoAlpha: 0,
    }, 0.35)
})

if (document.querySelector('.top') !== null) {
  top()
}
